// Network state for the offline banner and the D13 write guard.
import { useSyncExternalStore } from "react";

let offlineSince: Date | null = null;

function subscribe(cb: () => void): () => void {
  const on = () => { offlineSince = null; cb(); };
  const off = () => { offlineSince = offlineSince ?? new Date(); cb(); };
  window.addEventListener("online", on);
  window.addEventListener("offline", off);
  return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
}

export const isOnline = (): boolean => typeof navigator === "undefined" || navigator.onLine !== false;

export function useOnline(): { online: boolean; since: Date | null } {
  const online = useSyncExternalStore(subscribe, isOnline, () => true);
  if (!online && !offlineSince) offlineSince = new Date();
  return { online, since: online ? null : offlineSince };
}
